import { Container, Stack } from "@mui/material";
import React from "react";
import { GatsbyImage, IGatsbyImageData, getImage } from "gatsby-plugin-image";
import { graphql, useStaticQuery } from "gatsby";
import COLORS from "../constants/colors";

interface ImageNode {
  relativePath: string;
  childImageSharp: {
    gatsbyImageData: IGatsbyImageData;
  };
}

interface AppShowcaseRowProps {
  imgName: string;
  imgAlt: string;
  content: React.ReactNode | React.ReactNode[];
  gap?: string | undefined;
  reverse?: boolean;
}

const AppShowcaseRow = ({
  imgName,
  imgAlt,
  content,
  gap,
  reverse = false,
}: AppShowcaseRowProps) => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { extension: { regex: "/(jpg|jpeg|png|webp)/" } }) {
        nodes {
          relativePath
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 100
            )
          }
        }
      }
    }
  `);

  const imageNode = data.allFile.nodes.find(
    (node: ImageNode) => node.relativePath === imgName
  );

  if (!imageNode) {
    return <div>Bilde ikke funnet</div>;
  }

  const image = getImage(imageNode.childImageSharp.gatsbyImageData);

  if (!image) {
    return <div>Bilde ikke funnet</div>;
  }

  return (
    <Stack
      component="section"
      bgcolor={COLORS.WHITE[100]}
      py={{ xs: "40px", md: "80px" }}
    >
      <Container>
        <Stack
          gap={{ xs: "24px", md: "48px" }}
          flexDirection={{ xs: "column", md: reverse ? "row-reverse" : "row" }}
        >
          <Stack flex={{ xs: "1", md: "4" }} justifyContent="center">
            <GatsbyImage
              loading="lazy"
              alt={imgAlt}
              image={image}
              style={{
                aspectRatio: "1.5",
                width: "100%",
                height: "auto",
                borderRadius: "20px",
                objectFit: "cover",
              }}
            />
          </Stack>
          <Stack
            justifyContent="center"
            flex={{ xs: "1", md: "2" }}
            gap={gap ?? "24px"}
            alignItems="flex-start"
          >
            {content}
          </Stack>
        </Stack>
      </Container>
    </Stack>
  );
};
export default AppShowcaseRow;
